import { useState } from 'react';
import { changePassword } from '../services/changePasswordService';
import { ChangePasswordDto } from '../types/changePassword';

interface ModalState {
  isOpen: boolean;
  title: string;
  message: string;
  type: 'success' | 'error';
}

export const useChangePassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState<ModalState>({
    isOpen: false,
    title: '',
    message: '',
    type: 'success',
  });

  const executeChangePassword = async (
    dto: ChangePasswordDto,
    onSuccessCallback?: () => void
  ) => {
    setIsLoading(true);
    let isSuccess = false;
    let successMessage = '';

    // 1. Μόνο η κλήση του API μπαίνει στο try/catch
    try {
      const response = await changePassword(dto);
      isSuccess = true;
      successMessage = response.message || 'Ο κωδικός πρόσβασης άλλαξε επιτυχώς.';
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message ||
        'Αποτυχία αλλαγής κωδικού. Παρακαλώ δοκιμάστε ξανά.';

      setFeedbackModal({
        isOpen: true,
        title: 'Σφάλμα',
        message: errorMessage,
        type: 'error',
      });
      setIsLoading(false);
      return;
    }

    setIsLoading(false);

    // 2. Η διαχείριση επιτυχίας εκτελείται ΕΚΤΟΣ του API try/catch
    if (isSuccess) {
      setFeedbackModal({
        isOpen: true,
        title: 'Επιτυχία',
        message: successMessage,
        type: 'success',
      });

      if (onSuccessCallback) {
        try {
          onSuccessCallback();
        } catch (e) {
          console.error('Σφάλμα κατά την εκτέλεση του onSuccessCallback:', e);
        }
      }
    }
  };

  const closeFeedbackModal = () => {
    setFeedbackModal((prev) => ({ ...prev, isOpen: false }));
  };

  return {
    isLoading,
    feedbackModal,
    executeChangePassword,
    closeFeedbackModal,
  };
};